<div class="select-assessment">
  <ng-container
    *ngTemplateOutlet="
      assessmentSelectTemplate;
      context: { $implicit: assessmentInfo().selectedForAssessment }
    "></ng-container>
  @if (showSelectedCount) {
    <span class="counter">
      {{ assessmentInfo().nroSelectedForAssessment }} of {{ subAccountCount() }}
    </span>
  }

  @if (assessmentInfo().selectedForAssessment && isStatusAvailableForEditing(oversightStatus())) {
    <button
      [matMenuTriggerFor]="assessmentSelect"
      class="assessment-menu-trigger appearing-trigger edit-trigger">
      <mat-icon
        fontSet="material-symbols-outlined"
        [matTooltip]="'Edit selected assessment rights'">
        edit
      </mat-icon>
    </button>
  }
</div>

<mat-menu
  #assessmentSelect
  [xPosition]="'before'"
  class="custom-mat-menu">
  @for (option of assessmentOptions; track option.value) {
    <div [matTooltip]="getCorrectTooltipLabel(option.value)">
      <button
        mat-menu-item
        [value]="option.value"
        (click)="listSelectionChange(option.value)"
        [disabled]="
          assessmentInfo().selectedForAssessment === option.value ||
          (option.value === selectedType.NEW && assessmentInfo().hasCurrentAssessment) ||
          (option.value === selectedType.DISCARDED && assessmentInfo().hasCurrentAssessment)
        ">
        <div class="flex">
          <ng-container
            *ngTemplateOutlet="
              assessmentSelectTemplate;
              context: { $implicit: option.value }
            "></ng-container>
          {{ option.label | titlecase }}
        </div>
      </button>
    </div>
  }
  @if (subAccountCount() > 1) {
    <mat-divider></mat-divider>
    <button
      mat-menu-item
      class="manage-btn"
      (click)="manageLogicalStatus()">
      Manage per sub-account
    </button>
  }
</mat-menu>

<ng-template
  let-status
  #assessmentSelectTemplate>
  @switch (status) {
    @case (selectedType.NEW) {
      <span class="new-word">
        {{ selectedType.NEW | uppercase }}
      </span>
    }
    @case (selectedType.SELECTED) {
      <span><mat-icon class="done-icon">done</mat-icon></span>
    }
    @case (selectedType.DISCARDED) {
      <span>
        <mat-icon class="close-icon">close</mat-icon>
      </span>
    }
    @default {
      <span>-</span>
    }
  }
</ng-template>
